<template>
  <div class="c_panel">
    <div class="c_nav"></div>
    <div class="content">
      <div class="model">
        <div class="gridTitle"></div>
        <div class="gridInfo">Blueshark R1</div>
        <div class="gridInfo">Blueshark R1 lite</div>
        <div class="gridInfo">Blueshark R1D lite</div>
      </div>
      <div class="sub">
        <div class="subTitle">
          {{ $t('R1config.battery') }}
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.capacity') }}
          </div>
          <div class="infoContent  f1">
            1,440 Wh x2
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">{{ $t('R1config.NEDC') }} (km)</div>
          <div class="infoContent f1">
            110
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.powerType') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.automotive') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.charger') }}
          </div>
          <div class="infoContent f1">
            48V / 480W
          </div>
        </div>
      </div>
      <div class="sub">
        <div class="subTitle">
          {{ $t('R1config.performance') }}
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.motor') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.highSpeedMotor') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">{{ $t('R1config.topSpeed') }} (km/h)</div>
          <div class="infoContent f1">
            80
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">{{ $t('H1Product.config.c1') }} (W)</div>
          <div class="infoContent f1">
            3,000
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">{{ $t('R1config.peakPower') }} (W)</div>
          <div class="infoContent f1">
            5,000
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">{{ $t('R1config.torque') }} (N·m)</div>
          <div class="infoContent f1">
            201
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.gradability') }}
          </div>
          <div class="infoContent f1">
            40% (22°)
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.turbo') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.mam') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
        </div>
      </div>
      <div class="sub">
        <div class="subTitle">
          {{ $t('R1config.smart') }}
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.panel') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.IPSScreen') }}
          </div>
          <div class="infoContent f2">
            {{ $t('R1config.LCDScreen') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.bluetooth') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
          <div class="infoContent f2">
            {{ $t('R1config.no') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.frontalCamera') }}
          </div>
          <div class="infoContent f1">
            <div>
              {{ $t('R1config.optional') }}(1080P, 16G {{ $t('R1config.RAM') }})
            </div>
          </div>
          <div class="infoContent f2">
            {{ $t('R1config.no') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.RearCamera') }}
          </div>
          <div class="infoContent f1">
            <div>{{ $t('R1config.viewWhenTurn') }}</div>
          </div>
          <div class="infoContent f2">
            {{ $t('R1config.no') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.remainRange') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.bluesharkApp') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.wireless') }}
          </div>
          <div class="infoContent f1">
            4G / Wi-Fi / BT
          </div>
          <div class="infoContent f2">
            4G
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.sensors') }}
          </div>
          <div class="infoContent f1">
            74
          </div>
          <div class="infoContent f2">
            65
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.upgrade') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
        </div>
      </div>
      <div class="sub">
        <div class="subTitle">
          {{ $t('R1config.safe') }}
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.smartKey') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.steeringLock') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.seatLock') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.triMode') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.brake') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.CBS') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.ADAS') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
          <div class="infoContent f2">
            {{ $t('R1config.no') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.remoteAlarm') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.sideStand') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.virtualVroom') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
          <div class="infoContent f2">
            {{ $t('R1config.no') }}
          </div>
        </div>
      </div>
      <div class="sub">
        <div class="subTitle">
          {{ $t('R1config.light') }}
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.autoHeadlight') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.turnSignal') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.HazardLight') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.seatLight') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.carpetLight') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
          <div class="infoContent f2">
            {{ $t('R1config.no') }}
          </div>
        </div>
      </div>
      <div class="sub">
        <div class="subTitle">
          {{ $t('R1config.multimedia') }}
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.speaker') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
          <div class="infoContent f2">
            {{ $t('R1config.no') }}
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.HighPowerSpeaker') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.yes') }}
          </div>
          <div class="infoContent f2">
            {{ $t('R1config.no') }}
          </div>
        </div>
      </div>
      <div class="sub">
        <div class="subTitle">
          {{ $t('R1config.basic') }}
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.size') }} {{ $t('R1config.LWH') }}
          </div>
          <div class="infoContent f1">
            1,880*700*1,200 (mm)
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">{{ $t('R1config.wheelbase') }} (mm)</div>
          <div class="infoContent f1">
            1,300
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.tire') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.front') }} 100/90-12
            {{ $t('R1config.rear') }} 120/70-12
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">{{ $t('R1config.groundClearance') }} (mm)</div>
          <div class="infoContent f1">
            140
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">{{ $t('R1config.weight') }} (kg)</div>
          <div class="infoContent f1">
            92
          </div>
        </div>
        <div class="info">
          <div class="infoTitle">
            {{ $t('R1config.colors') }}
          </div>
          <div class="infoContent f1">
            {{ $t('R1config.color') }}
          </div>
        </div>
      </div>
      <div class="end"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: 'cn'
    }
  },
  mounted() {
    let that = this
    this.$nextTick(function() {
      window.addEventListener('scroll', that.animateTxt)
    })
    let lang = this.$route.path.slice(1, 3) || 'cn'
    this.$i18n.locale = this.lang = lang
    localStorage.setItem('lang', lang)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.animateTxt)
  },
  methods: {
    animateTxt() {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset
      if (top <= 100) {
        this.$emit('hidenav')
      } else {
        this.$emit('shownav')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/common.less';
.c_panel {
  .c_nav {
    height: 60px;
    background-color: #000;
  }
  .config {
    width: 60%;
    margin: 100px auto;
    .color_gray {
      font-size: 14px;
    }
    .configlist {
      display: flex;
      display: -webkit-flex;
      border-bottom: 1px solid #ddd;
      padding: 5px 0;
      line-height: 20px;
      .clistitem {
        flex: 1;
        font-size: 14px;
      }
      .bold {
        font-weight: bold;
      }
    }
    .configtitle {
      display: flex;
      display: -webkit-flex;
      line-height: 26px;
      height: 26px;
      font-weight: bold;
      border-bottom: 1px solid #000;
      .clistitem {
        flex: 1;
        font-size: 14px;
      }
    }
    .bs {
      margin-bottom: 30px;
    }
    .hint {
      font-size: 12px;
      font-weight: bold;
    }
  }
}
.content {
  width: 60%;
  margin: 100px auto;
  .model {
    display: flex;
    justify-content: space-between;
    height: 33px;
    line-height: 33px;
    text-align: center;
  }
  .gridTitle {
    width: 189px;
  }
  .gridInfo {
    flex: 1;
    width: 113px;
    font-size: 18px;
    font-weight: 500;
  }
  .subTitle {
    font-size: 19px;
    height: 33px;
    line-height: 33px;
    font-weight: 500;
    border-top: 1px solid #000;
  }
  .info {
    display: flex;
    justify-content: space-between;
    height: 33px;
    font-size: 19px;
    line-height: 20px;
    .infoTitle {
      display: flex;
      align-items: center;
      width: 220px;
      color: #666;
      border-top: 1px solid #d2d2d2;
      border-right: 1px solid #d2d2d2;
    }
    .infoContent {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      border-top: 1px solid #d2d2d2;
    }
    .f1 {
      flex: 1;
    }
    .f2 {
      flex: 2;
      border-left: 1px solid #d2d2d2;
    }
  }
}
.end {
  border-top: 1px solid #d2d2d2;
}
</style>



// WEBPACK FOOTER //
// src/components/R1config/config.vue